import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'nw-pill',
    templateUrl: './pill.component.html',
    styleUrl: './pill.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PillComponent {
    @Input() value?: string;
}
